// router.js
import { createRouter, createWebHistory } from 'vue-router';
import HomePage from './components/HomePage.vue';
import LoginPage from './components/LoginPage.vue';

const routes = [
    { path: '/home', component: HomePage, meta: { requiresAuth: true } },
    { path: '/', component: LoginPage },
    { path: '/login', component: LoginPage },
];

const router = createRouter({
    history: createWebHistory(),
    routes,
});

const { getCookie } = require('./helpers');

router.beforeEach(async (to, from, next) => {
    const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
    const requiresAdmin = to.matched.some(record => record.meta.requiresAdmin);

    if (to.path === '/login' || to.path === '/') {
        next();
        return;
    }

    if (requiresAuth || requiresAdmin) {
        try {
            const token = getCookie('token');
            if (!token) {
                next('/login');
                return;
            }
            const response = await fetch(`${router.apiUrl}/validate-token`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });
            // TODO: store username for greeting
            //const data = await response.json();
            await response.json();
            const isAuthenticated = response.ok;
            //            const isAdmin = data.user.isAdmin;

            if (requiresAuth && !isAuthenticated) {
                next('/login');
                // } else if (requiresAdmin && !isAdmin) {
                //     next('/home');
            } else {
                next();
            }
        } catch (error) {
            console.error('Token validation error:', error);
            next('/login');
        }
    } else {
        next();
    }
});

export default router;